module.exports = __webpack_public_path__ + "static/media/no-results@3x.fcebbc81.png";